export default class Feature {
  private _title: string
  private _tooltip?: string
  private _isHighlighted: boolean

  public constructor(title: string, tooltip = '', isHighlighted: boolean) {
    this._title = title
    this._tooltip = tooltip
    this._isHighlighted = isHighlighted
  }

  get title() {
    return this._title
  }

  get tooltip() {
    return this._tooltip
  }

  get isHighlighted() {
    return this._isHighlighted
  }
}
